import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("td", null, "ID"),
    /*#__PURE__*/_createElementVNode("td", null, "Name"),
    /*#__PURE__*/_createElementVNode("td", null, "Auth"),
    /*#__PURE__*/_createElementVNode("td", null, "Action"),
    /*#__PURE__*/_createElementVNode("td", null, "Method"),
    /*#__PURE__*/_createElementVNode("td", null, "Category"),
    /*#__PURE__*/_createElementVNode("td", null, "CreatedOn")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}

import { ref, onMounted } from "vue";
import SystemService from "../../services/SystemService";
import CreatePermission from "./CreatePermission.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionList',
  setup(__props) {

const isLoading = ref(false);
const data = ref<any>([]);
const tempData = ref<any>([]);
const criteria = ref({ page: 1, size: 20 });
const createPermissionRef = ref<InstanceType<typeof CreatePermission>>();

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await SystemService.getPermissions(criteria.value);
    data.value = res.data;
    tempData.value = res.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const createOrEdit = () => {
  createPermissionRef.value?.show();
};

const showByCategory = (category: string) => {
  data.value = tempData.value;
  data.value = data.value.filter((item: any) => {
    return item.category === category;
  });
};

const resetCategory = () => {
  data.value = tempData.value;
};

const pageChange = (page: number) => {
  fetchData(page);
};
onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (resetCategory()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("All")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showByCategory('API')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("API")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showByCategory('WEB')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Web")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (createOrEdit()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Create Permission ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.key), 1),
                      _createElementVNode("td", null, _toDisplayString(item.auth), 1),
                      _createElementVNode("td", null, _toDisplayString(item.action), 1),
                      _createElementVNode("td", null, _toDisplayString(item.method), 1),
                      _createElementVNode("td", null, _toDisplayString(item.category), 1),
                      _createElementVNode("td", null, _toDisplayString(item.createdOn), 1)
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: pageChange,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(CreatePermission, {
      ref_key: "createPermissionRef",
      ref: createPermissionRef,
      onSubmit: _cache[4] || (_cache[4] = ($event: any) => (fetchData(1)))
    }, null, 512)
  ], 64))
}
}

})